var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"caseview"},[_c('div',{staticClass:"casecontent",on:{"click":_vm.toCases}},[_c('img',{attrs:{"src":require("../assets/img/alhj_btn.png")}})])])}
var staticRenderFns = []

export { render, staticRenderFns }